import type { Sport } from '../../interfaces';
import { ALL_SPORTS_VALUE } from '../hooks/useMostPopularBetsAPI';

/**
 * Canonical (untranslated) sport name for a category group — the single source of truth for the
 * value used in analytics payloads (the all-sports bucket, the selected filter, etc.).
 */
export const getSportName = (sports: Sport[], categoryGroupId: number): string =>
  categoryGroupId === ALL_SPORTS_VALUE
    ? 'All Sports'
    : (sports.find(s => s.categoryGroupId === categoryGroupId)?.label ?? '');
